module.exports = __webpack_public_path__ + "img/quickRoute5.3e05e3fd.png";